module.exports = __webpack_public_path__ + "static/media/calendar-download.5608345a.svg";